import React, { useState } from "react";
import axios from "axios";
import { GetCookie } from "../../exports/CookieManagement";
import { Alert } from "../Body/CustomChartComponents/CustomAlert/CustomAlert";
import CustomSelect from "../Body/CustomChartComponents/CustomSelect/CustomSelect";
import CustomInput from "../Body/CustomChartComponents/CustomInput/CustomInput";
import CustomIconButton from "../Body/CustomChartComponents/CustomIconButton/CustomIconButton";
import { ArrowRight2 } from "../CustomComponents/SwiftIcon/Icons";
import Pulse from "../Loader/Pulse";
import { COLOR_VARS } from "../../exports/ColorVars";
import SwiftModal from "../CustomComponents/SwiftModal/SwiftModal";

let roles = ["Managed Customer", "Broking Customer"];
const REQUEST_BASE_URL = process.env.REACT_APP_REQUEST_BASE_URL;

function KYCClient() {
  const [pan, setPan] = useState("");
  const [role, setRole] = useState(roles[0]);
  const [panError, setPanError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(true);
  const [emailOtp, setEmailOtp] = useState("");
  const [otpsent, setOtpsent] = useState(false);
  const [otpVerified, setotpVerified] = useState(false);
  const [sendingOtp, setSendingOtp] = useState(false);
  const [verifyingOtp, setVerifyingOtp] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [formData, setFormData] = useState({
    mobile: "",
    name: "",
    email: "",
    address: {
      city: "",
      full: "",
      state: "",
      country: "",
      pincode: "",
      address_line_1: "",
      address_line_2: "",
      address_line_3: "",
    },
  });

  const handleAddressChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      address: {
        ...prev.address,
        [field]: value,
      },
    }));
  };

  function ValidatePAN(pan) {
    const regex = /[A-Z]{3}[PCHFATBLJG]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}$/;
    return regex.test(pan);
  }

  function AddClient() {
    if (!ValidatePAN(pan)) {
      setPanError("Please enter correct pan number");
      return;
    }

    setLoading(true);
    setPanError("");

    const account_token = GetCookie("token");

    axios
      .post(
        `${REQUEST_BASE_URL}/client/check-customers?token=${account_token}`,
        {
          // customer_type: role,
          pan_number: pan,
        },
      )
      .then((response) => {
        const data = response.data;
        setLoading(false);
        if (data.error) {
          if (data.exists) {
            Alert({
              TitleText: "Warning",
              Message: "A client with given PAN already exists",
              BandColor: "var(--main-blue)",
              AutoClose: {
                Active: true,
                Line: true,
                LineColor: "var(--main-blue)",
                Time: 3,
              },
            });
          } else {
            Alert({
              TitleText: "Failure",
              Message: "New customer has not been added",
              BandColor: "var(--red)",
              AutoClose: {
                Active: true,
                Line: true,
                LineColor: "var(--red)",
                Time: 3,
              },
            });
          }
        } else {
          setShowModal(true);
        }
      });
  }

  function SendOtp() {
    if (!formData.email) {
      setPanError("Please enter email address first");
      return;
    }

    setSendingOtp(true);
    const account_token = GetCookie("token");

    axios
      .post(
        `${REQUEST_BASE_URL}/client/send-email-otp?token=${account_token}`,
        {
          email: formData.email,
        },
      )
      .then((response) => {
        setSendingOtp(false);
        const data = response.data;
        if (data.error) {
          Alert({
            TitleText: "Failure",
            Message: "Invalid Email Address",
            BandColor: "var(--red)",
            AutoClose: {
              Active: true,
              Line: true,
              LineColor: "var(--red)",
              Time: 3,
            },
          });
        }
        setOtpsent(true);
      })
      .catch((err) => {
        setSendingOtp(false);
        Alert({
          TitleText: "Failure",
          Message: "Something went wrong",
          BandColor: "var(--red)",
          AutoClose: {
            Active: true,
            Line: true,
            LineColor: "var(--red)",
            Time: 3,
          },
        });
      });
  }

  function VerifyOtp() {
    if (!emailOtp) {
      setPanError("Please enter the OTP first");
      return;
    }

    setVerifyingOtp(true);
    const account_token = GetCookie("token");

    axios
      .post(
        `${REQUEST_BASE_URL}/client/validate-email-otp?token=${account_token}`,
        {
          email: formData.email,
          otp: emailOtp,
        },
      )
      .then((response) => {
        setVerifyingOtp(false);
        const data = response.data;
        if (data) {
          setotpVerified(true);
        } else {
          Alert({
            TitleText: "Failure",
            Message: "Invalid OTP",
            BandColor: "var(--red)",
            AutoClose: {
              Active: true,
              Line: true,
              LineColor: "var(--red)",
              Time: 3,
            },
          });
        }
      })
      .catch((err) => {
        setVerifyingOtp(false);
        Alert({
          TitleText: "Failure",
          Message: "An error occurred while verifying OTP",
          BandColor: "var(--red)",
          AutoClose: {
            Active: true,
            Line: true,
            LineColor: "var(--red)",
            Time: 3,
          },
        });
      });
  }

  function SaveDetails() {
    const errors = {};
    if (!formData.name.trim()) errors.name = "Name is required";
    if (!formData.mobile.trim()) errors.mobile = "Mobile number is required";
    if (!formData.email.trim()) errors.email = "Email address is required";
    if (!formData.address.address_line_1.trim())
      errors.address_line_1 = "Address line 1 is required";
    if (!formData.address.address_line_2.trim())
      errors.address_line_2 = "Address line 2 is required";
    if (!formData.address.city.trim()) errors.city = "City is required";
    if (!formData.address.state.trim()) errors.state = "State is required";
    if (!formData.address.country.trim())
      errors.country = "Country is required";
    if (!formData.address.pincode.trim())
      errors.pincode = "Pincode is required";

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      Alert({
        TitleText: "Warning",
        Message: "Please fill in all mandatory fields",
        BandColor: "var(--main-blue)",
        AutoClose: {
          Active: true,
          Line: true,
          LineColor: "var(--main-blue)",
          Time: 3,
        },
      });
      return;
    }

    setFormErrors({});
    setLoading(true);

    const data = {
      ...formData,
      address: {
        ...formData.address,
        full:
          formData.address.address_line_1 +
          " " +
          formData.address.address_line_2 +
          " " +
          formData.address.city +
          " " +
          formData.address.state +
          " " +
          formData.address.country +
          " " +
          formData.address.pincode,
      },
    };
    const account_token = GetCookie("token");

    axios
      .post(
        `${REQUEST_BASE_URL}/client/save-client-details?token=${account_token}`,
        {
          name: formData.name,
          mobile: formData.mobile,
          email: formData.email,
          address: data.address,
          pan: pan,
        },
      )
      .then((response) => {
        setLoading(false);
        const resData = response.data;
        if (resData.error) {
          Alert({
            TitleText: "Failure",
            Message: resData.message || "Failed to save customer details",
            BandColor: "var(--red)",
            AutoClose: {
              Active: true,
              Line: true,
              LineColor: "var(--red)",
              Time: 3,
            },
          });
        } else {
          Alert({
            TitleText: "Success",
            Message: "Customer details saved successfully!",
            BandColor: "var(--green)",
            AutoClose: {
              Active: true,
              Line: true,
              LineColor: "var(--green)",
              Time: 3,
            },
          });
          setShowModal(false);
          setPan("");
          setFormData({
            mobile: "",
            name: "",
            email: "",
            address: {
              city: "",
              full: "",
              state: "",
              country: "",
              pincode: "",
              address_line_1: "",
              address_line_2: "",
              address_line_3: "",
            },
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        Alert({
          TitleText: "Failure",
          Message: "An error occurred while saving details",
          BandColor: "var(--red)",
          AutoClose: {
            Active: true,
            Line: true,
            LineColor: "var(--red)",
            Time: 3,
          },
        });
      });
  }

  return (
    <div className="client-add">
      <p className="title">Add Customer KYC</p>
      {loading && (
        <>
          <div className="client-add-loader">
            <Pulse />
          </div>
        </>
      )}

      <div className="client-kyc-container">
        <CustomSelect
          heading="Type of Customer"
          defaultIndex={0}
          value={role}
          options={roles}
          onTypeChange={(value) => {
            setRole(value);
          }}
        />
        <div className="client-pan">
          <CustomInput
            heading="Permanent Account Number (PAN)"
            placeholder="Enter PAN number of client"
            value={pan}
            onChange={(value) => {
              setPan(value.toUpperCase());
            }}
            maxLength={10}
            error={panError}
          />
        </div>
        <div className="step-button">
          <CustomIconButton
            title="Add Client"
            onClick={() => {
              AddClient();
            }}
            icon={null}
          />
        </div>
      </div>
      {showModal && (
        <SwiftModal
          closeModal={() => {
            setShowModal(false);
            setPan("");
          }}
          top="5%"
        >
          <div className="modal-form-container">
            <p className="modal-title">KYC Customer Details</p>

            <CustomInput
              heading={
                <>
                  Name <span className="mandatory-asterisk">*</span>
                </>
              }
              placeholder="Enter Name"
              value={formData.name}
              onChange={(val) => setFormData({ ...formData, name: val })}
              error={formErrors.name}
            />
            <CustomInput
              heading={
                <>
                  Mobile <span className="mandatory-asterisk">*</span>
                </>
              }
              placeholder="Enter Mobile"
              value={formData.mobile}
              type="tel"
              maxLength={10}
              onChange={(val) =>
                setFormData({
                  ...formData,
                  mobile: val.replace(/[^\d]/g, "").slice(0, 10),
                })
              }
              error={formErrors.mobile}
            />
            <div className="form-row email-otp-row">
              <div className="email-col">
                <CustomInput
                  heading={
                    <>
                      Email <span className="mandatory-asterisk">*</span>
                    </>
                  }
                  placeholder="Enter Email"
                  value={formData.email}
                  onChange={(val) => setFormData({ ...formData, email: val })}
                  disabled={otpVerified}
                  error={formErrors.email}
                />
              </div>
              <div className="verify-col">
                <div className="swift-input-box">
                  <p className="spacer-label">Spacer</p>
                  <button
                    className="btn-outline verify-otp-btn"
                    onClick={SendOtp}
                    disabled={sendingOtp || otpVerified}
                  >
                    {sendingOtp ? "Sending..." : "Send OTP"}
                  </button>
                </div>
              </div>
              {otpsent && (
                <>
                  <div className="otp-col">
                    <CustomInput
                      heading={
                        <>
                          Email OTP{" "}
                          <span className="mandatory-asterisk">*</span>
                        </>
                      }
                      placeholder="Enter Email OTP"
                      value={emailOtp}
                      maxLength={6}
                      type="tel"
                      onChange={(val) =>
                        setEmailOtp(val.replace(/[^\d]/g, "").slice(0, 6))
                      }
                      disabled={otpVerified}
                    />
                  </div>
                  <div className="verify-col">
                    <div className="swift-input-box">
                      <p className="spacer-label">Spacer</p>
                      <button
                        className="btn-outline verify-otp-btn"
                        onClick={VerifyOtp}
                        disabled={verifyingOtp || otpVerified}
                      >
                        {verifyingOtp
                          ? "Verifying..."
                          : otpVerified
                            ? "Verified"
                            : "Verify OTP"}
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>

            <p className="address-title">Address</p>

            <CustomInput
              heading={
                <>
                  Address Line 1 <span className="mandatory-asterisk">*</span>
                </>
              }
              placeholder="Enter Address Line 1"
              value={formData.address.address_line_1}
              onChange={(val) => handleAddressChange("address_line_1", val)}
              error={formErrors.address_line_1}
            />

            <CustomInput
              heading={
                <>
                  Address Line 2 <span className="mandatory-asterisk">*</span>
                </>
              }
              placeholder="Enter Address Line 2"
              value={formData.address.address_line_2}
              onChange={(val) => handleAddressChange("address_line_2", val)}
              error={formErrors.address_line_2}
            />

            <CustomInput
              heading="Address Line 3"
              placeholder="Enter Address Line 3"
              value={formData.address.address_line_3}
              onChange={(val) => handleAddressChange("address_line_3", val)}
            />

            <div className="form-row">
              <div className="form-col">
                <CustomInput
                  heading={
                    <>
                      City <span className="mandatory-asterisk">*</span>
                    </>
                  }
                  placeholder="Enter City"
                  value={formData.address.city}
                  onChange={(val) => handleAddressChange("city", val)}
                  error={formErrors.city}
                />
              </div>
              <div className="form-col">
                <CustomInput
                  heading={
                    <>
                      State <span className="mandatory-asterisk">*</span>
                    </>
                  }
                  placeholder="Enter State"
                  value={formData.address.state}
                  onChange={(val) => handleAddressChange("state", val)}
                  error={formErrors.state}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-col">
                <CustomInput
                  heading={
                    <>
                      Country <span className="mandatory-asterisk">*</span>
                    </>
                  }
                  placeholder="Enter Country"
                  value={formData.address.country}
                  onChange={(val) => handleAddressChange("country", val)}
                  error={formErrors.country}
                />
              </div>
              <div className="form-col">
                <CustomInput
                  heading={
                    <>
                      Pincode <span className="mandatory-asterisk">*</span>
                    </>
                  }
                  placeholder="Enter Pincode"
                  value={formData.address.pincode}
                  onChange={(val) => handleAddressChange("pincode", val)}
                  error={formErrors.pincode}
                />
              </div>
            </div>

            <div className="modal-actions">
              <CustomIconButton
                title="Save Details"
                disabled={!otpVerified || loading}
                onClick={SaveDetails}
                icon={null}
              />
            </div>
          </div>
        </SwiftModal>
      )}
    </div>
  );
}

export default KYCClient;
